var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsernameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "username_icon",
    transform: "translate(-278 -1339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M26,0H0V26H26Z",
    transform: "translate(278 1339)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M13.852,5.367A3.117,3.117,0,1,1,10.735,2.25a3.117,3.117,0,0,1,3.117,3.117ZM4.5,17.1a6.234,6.234,0,1,1,12.468,0A15,15,0,0,1,4.5,17.1Z",
    transform: "translate(280.265 1341.645)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameIcon);
export default __webpack_public_path__ + "static/media/username_icon.b879479e3d6f85d6fa4326891450c32b.svg";
export { ForwardRef as ReactComponent };